import React from "react";
import './titledisplayer.css'
import { useInView } from "react-intersection-observer";

function TitleDisplayerComponent({text, color}) {
  const {ref:titleDisplayer, inView: titleDisplayerAnimated } = useInView({
    "threshold":1,
    "initialInView":true
  });
  return (
    

    <div ref={titleDisplayer} className={`separator ${titleDisplayerAnimated ? "separatorAnimated": ""}`}>
    
    <h2 style={{color : color ? color : color="rgb(16, 17, 80)"}}>{text}</h2>
    
  </div>
  );
}

export default TitleDisplayerComponent;
